<template>
  <div class="aboutMe">
    <!-- 关于我们的信息展示 -->
    <div class="aboutMe_logo">
      <div class="my_logo">
        <img src="../../../static/img/15223848.png"
             alt="">
        <div class="my_logo_name">
          <h1>{{simple}}</h1>
          <h2> • 这是一间有追求的潮流商城 • </h2>
        </div>
      </div>

      <!-- 文字介绍部分 -->
      <div class="my_logo_info">
        <h1>关于我们</h1>
        <div>{{simple}}，一间专注于潮流时尚服饰的商城，一间超有爱的服饰分享小天地，
          我们始终跟随潮流的脚步，致力于给大家带来符合当下潮流趋势的服饰，给予各位更好的体验。
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { footerObj } from "@/assets/config.js"
var footer = footerObj[window.location.hostname];
 document.title = footer.simple
export default {
  data () {
    return {
      simple: footer.simple
    }
  }
}
</script>

<style>
.aboutMe {
  margin-top: 30px;
  width: 100%;
  height: 1000px;
}

.aboutMe_logo {
  border-radius: 10px;
  margin: 0 auto;
  width: 80%;
  height: 800px;
  border: 1px dotted #9e9e9e;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.my_logo {
  margin-top: 100px;
  width: 60%;
  height: 300px;
  /* background: #9e9e9e; */
  border-bottom: 1px dotted #9e9e9e;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-around;
}
.my_logo_name {
  box-sizing: border-box;
  padding: 20px;
  width: 300px;
  height: 100px;
  display: inline-block;
}
.my_logo_name h1 {
  text-align: center;
  line-height: 20px;
  height: 20px;
  color: rgb(228, 110, 110);
  font-size: 20px;
  font-style: italic;
  font-weight: bold;
  font-family: "Arial", "SimHei";
}
.my_logo_name h2 {
  margin-top: 10px;
  width: 100%;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #9e9e9e;
  font-size: 15px;
  font-family: "SimHei";
}

.my_logo_info {
  margin-top: 50px;
  width: 70%;
  height: 100%;
  text-align: center;
}
.my_logo_info h1 {
  color: #141414;
  text-align: center;
  font-size: 20px;
  font-family: "SimHei";
}

.my_logo_info div {
  margin-top: 30px;
  text-align: left;
  line-height: 50px;
}
</style>




// WEBPACK FOOTER //
// src/components/aboutMe/aboutMe.vue